import {logIfDev} from "~/util/envUtil";

export const injectGtm = (gtmId: string): Promise<void> => {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src*="gtm.js?id=${gtmId}"]`)) {
      console.log(`Gtm with ID ${gtmId} is already added.`);
      return;
    }

    if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
      logIfDev("Initializing dataLayer.");
      window.dataLayer = [];
    } else {
      logIfDev("Using existing dataLayer:", window.dataLayer);
    }
    // Needed each time before a new gtm is injected
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // Dynamically inject gtm script
    const gtmScript = document.createElement("script");
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    gtmScript.async = true;
    document.head.insertBefore(gtmScript, document.head.firstChild);

    gtmScript.onerror = () => {
      console.error("Failed to load gtm script with ID", gtmId);
    };
    gtmScript.onload = () => {
      logIfDev("Gtm script loaded successfully with ID", gtmId);
    };
    resolve();
  });
};

export const removeGtm = (): Promise<void> => {
  return new Promise((resolve) => {
    // Removes all external third party scripts, because gtm allows A LOT
    getAllThirdPartyScripts().forEach((script) => script.remove());

    // Clear global gtm state
    delete window.google_tag_manager;
    delete (window as any).google_tag_data;
    delete (window as any).gtag;
    delete (window as any).fbq;

    // Empty the dataLayer
    window.dataLayer = [];

    logIfDev("Gtm removed and dataLayer cleared.");

    resolve();
  });
};

const getAllThirdPartyScripts = (): HTMLScriptElement[] =>
  Array.from(document.querySelectorAll("script")).filter(isThirdPartyScript);

const isThirdPartyScript = (script: HTMLScriptElement): boolean =>
  (script.getAttribute("src") || "").startsWith("http");
